module.exports = __webpack_public_path__ + "assets/img/Group26.0c5259f3.png";